import { render, staticRenderFns } from "./insurance_list.vue?vue&type=template&id=a70fff2e&scoped=true&"
import script from "./insurance_list.vue?vue&type=script&lang=js&"
export * from "./insurance_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70fff2e",
  null
  
)

export default component.exports